export const VALUE_LIST_TABS = ["all", "referentials", "contactOrganisation", "finance"];
/**
 * CONSTRAINT: the three category tabs are empty because a catalogue carries no category yet. Once
 * it does, this is the one place that maps a list to its tabs; the view only counts and renders.
 */
export function listsInTab(lists, tab) {
    return tab === "all" ? lists : [];
}
/** fr-CA has no name of its own in the catalogue and reads the French one, as any unknown locale. */
export function valueListName(list, locale) {
    const language = locale.split("-")[0].toLowerCase();
    return (language === "en" || language === "nl" ? list.names[language] : "") || list.names.fr;
}
